import '../styles/HomeUseCases.scss';
import { Row, Col } from 'react-simple-flex-grid';
import { useInView } from 'react-intersection-observer';

export const HomeUseCasesBlock = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <>
      <div
        ref={ref}
        className={inView ? 'use-cases-wrapper slideInUp' : 'use-cases-wrapper'}
      >
        <div className="section-shadow section-shadow-from-top"></div>
        <div className="section-header">
          <h2 className="block-title">Use cases</h2>
          <h3 className="block-subtitle">
            Anair’s technological base is flexible and powerful — it can be
            deployed to industries to usher in a new age of digitally guided
            human experience.
          </h3>
        </div>
        <div className="cards-container">
          <Row align="bottom">
            <Col xs={12} md={4}>
              <div className="card card-first">
                <h4 className="card-title">In-store Experience</h4>
                <p className="card-description">
                  AI-powered digital assistants automate repetitive tasks and
                  deliver instant product information, so your team can focus on
                  creating exceptional customer experiences.
                </p>
                <h4 className="card-title">Impact:</h4>
                <p className="card-description">
                  Higher customer retention, reduced return rates, and increased
                  revenue per customer.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="card card-second">
                <h4 className="card-title">Gaming</h4>
                <p className="card-description">
                  Integrates real-time perception with voice, vision, and haptic
                  feedback to create dynamic, physical experiences that pull
                  players into the action.
                </p>
                <h4 className="card-title">Impact:</h4>
                <p className="card-description">
                  Enhanced engagement, extended session time, and new
                  monetization opportunities.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="card card-third">
                <h4 className="card-title">Brand Awareness</h4>
                <p className="card-description">
                  Companies stand out at trade shows with dynamic onsite
                  experiences — using innovative technologies in live demos with
                  heaps of wow factor.
                </p>
                <h4 className="card-title">Impact:</h4>
                <p className="card-description">
                  More booth traffic, higher lead capture, and brand
                  differentiation.
                </p>
              </div>
            </Col>
          </Row>
        </div>
        <div className="section-shadow section-shadow-from-bottom"></div>
      </div>
    </>
  );
};
